import { combineReducers } from "redux";
import { ContactMethod } from "../types";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { CREATE_CONTACT_METHOD_REQUEST, FETCH_CONTACT_METHODS_REQUEST } from "./constants";
import { Action } from "./types";

function items(state: ContactMethod[] = [], action: Action): ContactMethod[] {
  switch (action.type) {
    case getSuccessActionType(FETCH_CONTACT_METHODS_REQUEST):
      return action.payload;

    case getSuccessActionType(CREATE_CONTACT_METHOD_REQUEST):
      return [...state, action.payload];

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case CREATE_CONTACT_METHOD_REQUEST:
    case FETCH_CONTACT_METHODS_REQUEST:
      return true;

    case getFailureActionType(CREATE_CONTACT_METHOD_REQUEST):
    case getSuccessActionType(CREATE_CONTACT_METHOD_REQUEST):
    case getFailureActionType(FETCH_CONTACT_METHODS_REQUEST):
    case getSuccessActionType(FETCH_CONTACT_METHODS_REQUEST):
      return false;

    default:
      return state;
  }
}

export const contacts = combineReducers({ items, isFetching });
